<template>
  <div
    v-if="appUpdateState.visible"
    class="app-update-banner"
    role="alert"
  >
    <span class="app-update-banner__message">{{ appUpdateState.message }}</span>
    <div class="app-update-banner__actions">
      <button
        type="button"
        class="btn btn-sm btn-white mb-0"
        @click="refreshApp"
      >
        Refresh
      </button>
      <button
        v-if="appUpdateState.reason === 'version'"
        type="button"
        class="btn btn-sm btn-link text-white mb-0"
        @click="dismissAppUpdateBanner"
      >
        Later
      </button>
    </div>
  </div>
</template>

<script>
import {
  appUpdateState,
  dismissAppUpdateBanner,
  refreshApp,
} from "@/helpers/appUpdateCheck";

export default {
  name: "AppUpdateBanner",
  setup() {
    return {
      appUpdateState,
      dismissAppUpdateBanner,
      refreshApp,
    };
  },
};
</script>

<style scoped>
.app-update-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1rem;
  padding: 0.75rem 1.25rem;
  background: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
  color: #fff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

.app-update-banner__message {
  font-size: 0.875rem;
  text-align: center;
}

.app-update-banner__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
